import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import "./WhatWeDo.css";

const WhatWeDo = () => {
  const imgSrc = `${process.env.PUBLIC_URL}/service01.jpg`;

  const features = [
    "Real-Time Booking and Service Updates",
    "Safe, Eco-Friendly Products for Every Room",
    "Seamless Scheduling That Fits Your Lifestyle",
    "Trained and Background-Checked Professionals",
    "100% Satisfaction Guarantee"
  ];

  return (
    <section className="whatWeDo" aria-labelledby="what-we-do-heading">
      <div className="whatWeDo__backgroundPattern" aria-hidden="true"></div>

      <div className="whatWeDo__container">
        {/* TEXT SIDE */}
        <div className="whatWeDo__content">
          <header className="whatWeDo__header">
            <span className="whatWeDo__subtitle">What We Do</span>
            <h2 id="what-we-do-heading" className="whatWeDo__title">
              Premium <span className="whatWeDo__titleHighlight">Cleaning</span> Solutions
            </h2>
            <div className="whatWeDo__divider"></div>
          </header>

          <p className="whatWeDo__description">
            We deliver a hassle-free cleaning experience with trusted professionals, flexible
            scheduling, and a commitment to spotless results every time.
          </p>

          <ul className="whatWeDo__featuresList">
            {features.map((feature, index) => (
              <li key={index} className="whatWeDo__featureItem">
                <FaCheckCircle className="whatWeDo__featureIcon" aria-hidden="true" />
                <span className="whatWeDo__featureText">{feature}</span>
              </li>
            ))}
          </ul>

          {/* Improved anchor with more descriptive text */}
          <a
            href="https://book.housecallpro.com/book/GreenWorks-Carpet-Cleaning/d68f1199665f4437a75d2123c4ec5398?v2=true&merchant_id=3e43968f-48c3-4024-983a-da9b85be73d9&hl=en-US"
            target="_blank"
            rel="noopener noreferrer"
            className="whatWeDo__ctaButton"
            aria-label="Schedule your professional cleaning with GreenWorks Carpet Cleaning (opens in new tab)"
          >
            <span className="whatWeDo__ctaText">
              Schedule Your Professional Cleaning Now
            </span>
            <svg
              className="whatWeDo__ctaIcon"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>

        {/* IMAGE SIDE */}
        <div className="whatWeDo__imageWrapper">
          <img
            src={imgSrc}
            alt="Professional cleaning service in action"
            className="whatWeDo__image"
            loading="lazy"
            decoding="async"
            width="600"
            height="500"
          />
          <div className="whatWeDo__imageOverlay" aria-hidden="true"></div>
          <div className="whatWeDo__imageShine" aria-hidden="true"></div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;